/**
 * Ball type enum.
 */
export enum BallTypeEnum {
  Unknown,
  Cue,
  Stripe,
  Solid,
  Eight,
  Red,
  Color,
}
